import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'



import Pagination from "../../services/Pagination";
import { Table, Form } from 'react-bootstrap'


import ModalInversionEditar from './ModalInversionEditar'

import ModalInversionFicha from './ModalInversionFicha'



import { tipoInversion, calcularTiempoTranscurrido } from '../../services/funcionesPublicas'


const AsesorInversiones = () =>{


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 10
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( false )

  const skull = { results: [] }

  const [ tramites, setResultados ] = useState<any>([])

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint(`tramites/inversiones/clientes/${arreglo_estatus}/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e:any){

      if (e.response?.status) {
        switch (e.response.status) {
          case 404:
            toast.error("Debes escribir algo")
            break;
          default:
            toast.error(e.response?.data)
        }
      }
      else{
        toast.error("Problemas con la busqueda")
      }
      setCargando(false)

    }
  }


  const busqueda = async () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setCurrentPage(1)
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true,true,true,true,true,true])


  const todos = () =>{
    setEstatus([true,true,true,true,true,true])
  }
  const ninguno = () =>{
    setEstatus([false,false,false,false,false,false])
  }


      React.useEffect(() => {
        busqueda()
      }, []);



  const [ inversion_seleccionada, setInversionSeleccionada ] = useState<any>(null)
  const [ show_ModalInversionEditar, setModalInversionEditar ] = useState<boolean>(false)
  const handleShow_ModalInversionEditar = (inversion:any) => {
    setInversionSeleccionada(inversion)
    setModalInversionEditar(true)
  }
  const handleClose_ModalInversionEditar = () => {
        busqueda()
    setModalInversionEditar(false)
  }




  const [ show_ModalInversionFicha, setModalInversionFicha ] = useState<boolean>(false)
  const handleShow_ModalInversionFicha = (inversion:any) => {
    setInversionSeleccionada(inversion)
    setModalInversionFicha(true)
  }
  const handleClose_ModalInversionFicha = () => {
        busqueda()
    setModalInversionFicha(false)
  }


      return (
          <>
            <div className="container-fluid">

              <div className="row justify-content-center">
                <div className="col-10 col-sm-11">

                    <h4>Inversiones</h4>
                    <hr/>







                    <div className="row">
                    
                        <div className="mb-2">
                            <label className="form-label">Búsqueda</label>
                            <div className="hstack gap-3">
                              <input className="form-control me-auto" type="text"  onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                              <button type="button" onClick={busqueda}  className="btn btn-secondary"><i className="fa fa-search" /></button>
                              <div className="vr"></div>
                              <button type="button" onClick={(e:any)=>{setTextoBusqueda('')}} className="btn btn-outline-danger"><i className="fa fa-trash"/></button>
                            </div>
                        </div>
                        
                        <div>
                          <Form.Check inline name="group1" type="checkbox" label="CAPTURA" checked={arreglo_estatus[0]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[0] = e.target.checked;  setEstatus(ne);}} id={`opciones_1`} />
                          <Form.Check inline name="group1" type="checkbox" label="MESA ATENCIÓN" checked={arreglo_estatus[1]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[1] = e.target.checked;  setEstatus(ne);}} id={`opciones_2`} />
                          <Form.Check inline name="group1" type="checkbox" label="ESPERA DE CONTRATO" checked={arreglo_estatus[2]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[2] = e.target.checked;  setEstatus(ne);}} id={`opciones_3`} />
                          <Form.Check inline name="group1" type="checkbox" label="EN INVERSIÓN" checked={arreglo_estatus[3]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[3] = e.target.checked;  setEstatus(ne);}} id={`opciones_4`} />
                          <Form.Check inline name="group1" type="checkbox" label="FINALIZADO" checked={arreglo_estatus[4]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[4] = e.target.checked;  setEstatus(ne);}} id={`opciones_5`} />
                          <Form.Check inline name="group1" type="checkbox" label="TERMINÓ ANTES" checked={arreglo_estatus[5]} onChange={(e)=>{ var ne = [...arreglo_estatus]; ne[5] = e.target.checked;  setEstatus(ne);}} id={`opciones_6`} />
                        </div>

                      <ul className="list-inline">
                        <li className="list-inline-item"><small className="pointer" onClick={()=>{todos()}}>Todos</small> / <small className="pointer" onClick={()=>{ninguno()}}>Ninguno</small></li>
                      </ul>

                    </div>







                          {  (!cargando_) && (

                              <>

                                   {
                                     tramites.length > 0 && (

                                       <>


                                       <h5>Resultados</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col">Estatus</th>
                                              <th scope="col">Folio</th>
                                              <th scope="col">Tipo de Retiro</th>
                                              <th scope="col">Cliente</th>
                                              <th scope="col">Creación</th>
                                              <th scope="col"></th>
                                              <th scope="col"></th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              tramites.map( (tramite:any,indice:number) =>
                                                  <tr key={ Math.random().toString(36).substr(2, 9) } style={{fontSize:12}}>
                                                    <td className="v text-left" style={{"width":"160px"}}>

                                                            <p className="nm"><small>{tramite.estatus}</small></p>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"180px"}}>
                                                        <small> {tramite.folio}</small>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"250px"}}>
                                                        <small> {tipoInversion(tramite.tipo_retiro)}</small>
                                                    </td>
                                                    <td className="v text-left"  >
                                                        <p className="nm"><small><b>{tramite.nombres}</b></small></p>
                                                        <small>{tramite.paterno} {tramite.materno}</small>
                                                    </td>
                                                    <td className="v text-left" style={{"width":"180px"}}>
                                                        <p className="nm"><small> {tramite.fecha_creacion} HRS</small></p>
                                                        <b>{calcularTiempoTranscurrido(tramite.fecha_creacion)}</b>

                                                    </td>
                                                    <td className="v text-left" style={{"width":40}}>
                                                        <button onClick={(e:any)=>{handleShow_ModalInversionFicha(tramite)}} className="btn btn-info btn-sm"><i className="fa fa-address-card-o"/></button>
                                                    </td>
                                                    <td className="v text-left" style={{"width":40}}>
                                                        

                                                      {
                                                        [10].indexOf(tramite.idestatus) > -1 &&
                                                        (
                                                            <button onClick={(e:any)=>{handleShow_ModalInversionEditar(tramite)}} className="btn btn-warning btn-sm"><i className="fa fa-edit"/></button>
                                                          )
                                                      }
                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}





                    
                </div>
              </div>

            </div>



  {
    show_ModalInversionEditar && (
      <ModalInversionEditar show={show_ModalInversionEditar} handleClose={handleClose_ModalInversionEditar} inversion={inversion_seleccionada} />
      )

  }



  {
    show_ModalInversionFicha && (
      <ModalInversionFicha show={show_ModalInversionFicha} handleClose={handleClose_ModalInversionFicha} inversion={inversion_seleccionada}  />
      )

  }



          </>

      );
  

}

export default AsesorInversiones
